<template>
    <div class="info-text">
        <!-- Content -->
    </div>
</template>
